import { Provider } from '@angular/core';

import { ApprovalsRepository } from '@efficiently/client-api-approvals';

import { ApprovalsGqlRepository } from './repositories/approvals-gql.repository';

export const approvalsProviders: Provider[] = [{ provide: ApprovalsRepository, useClass: ApprovalsGqlRepository }];
